import apiClient from '@/api/index'
import router from '@/router';

export const screenSaversModule = {
    namespaced: true,

    state:() => ({
        points_of_sale: null,
    }),

    actions: {
        async getPointOfSale({}) {
            return apiClient.get("/projects/tcode/shops/", {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                for(let i = 0; i < response.data.length; i++) {
                    response.data[i].label = response.data[i].name
                    response.data[i].value = response.data[i].code
                }

                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async fetchScreens({}, query) {
            return apiClient.get(`/projects/${query.project}/shops/${query.shop}/media/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async fetchCurrentScreens({}, data) {
            return apiClient.get(`/projects/${data.query.project}/shops/${data.query.shop}/media/${data.id}`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }
}